import moment from 'moment'

export default function (value) {
  if (value === undefined || value === null) {
    return null
  }
  return moment(value).format('DD.MM.YYYY')
}
